import React, { Component } from "react";
import {
  Card,
  Button,
  Table,
  Modal,
  Select,
  Input,
  Row,
  Col,
  Tooltip,
  BackTop,
  message,
  Checkbox,
} from "antd";
import { connect } from "react-redux";
import {
  req_page_gqm_alumniSurvey,
  req_downloadfile_ams_graduatealumni,
  req_delete_ams_graduatealumni,
} from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { getGraduateAcademicYear } from "../../utils/dateUtil";

import AdumniSingle from "./../alumni/alumni-single-modal";
import SurveyFirstYearModal from "./survey-first-year-modal";
import SurveyThreeYearModal from "./survey-three-year-modal";
import SurveyFiveYearModal from "./survey-five-year-modal";
import SurveyResponseModal from "./survey-response-modal";
import CounselorEditAlumniModal from "./counselor-edit-alumni-modal";

class SurveyAlumniList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "1",
    loading: false,
    domnloadFile: "",
    isShowAlumniInfoModal: false,
    isShowSurveyFirstModal: false,
    isShowSurveyThreeModal: false,
    isShowSurveyFiveModal: false,
    isShowSurveyResponseModal: false,
    isEditAlumniInfoModal: false,
    //responseYearSurveyCode: '',

    /*特定參數*/
    searchFieldExtA: getGraduateAcademicYear(new Date()) - 1,
    searchFieldExtB: "NONE",
    searchFieldExtC: "NONE",
    searchFieldExtD: "NONE",
    searchFieldExtE: "",
    undone: "NONE",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
      undone,
    } = this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_gqm_alumniSurvey(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
      undone
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
      undone,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_ams_graduatealumni(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      token,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
      undone
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "畢業135年校友清單";
    a.click();
  };

  api_delete_item = async (key) => {
    //console.log(key);
    const { token, userCode } = this.props.user;
    const result = await req_delete_ams_graduatealumni(key, userCode, token);
    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學年度",
        dataIndex: "YearGrade",
        width: 35,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "部別",
        dataIndex: "Division",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學制",
        dataIndex: "EducationalSystem",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "系所",
        dataIndex: "DepartmentName",
        width: 80,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "姓名",
        dataIndex: "StudentName",
        width: 50,
        render: (text, record) => {
          const { userLevel } = this.state;
          return (
            <div className="text-left">
              {userLevel === "MANAGER" ? (
                <Button
                  size="small"
                  style={{ color: "gray" }}
                  onClick={() => this.handle_show_ui_modal("delete", record)}
                >
                  <i className="fa fa-user-times"></i>
                </Button>
              ) : (
                ""
              )}
              <span style={{ fontSize: "1.2em" }}> {text}</span>
              {record.EmailPrincipal !== "" ? (
                <Tooltip placement="topLeft" title={record.EmailPrincipal}>
                  <span>
                    {" "}
                    <a href={"mailto:" + record.EmailPrincipal}>
                      <i className="far fa-envelope"></i>
                    </a>
                  </span>
                </Tooltip>
              ) : (
                ""
              )}{" "}
              {record.MobilePrincipal !== "" ? (
                <Tooltip placement="topLeft" title={record.MobilePrincipal}>
                  <span>
                    {" "}
                    <a href={"tel:" + record.MobilePrincipal}>
                      <i className="fas fa-mobile-alt"></i>
                    </a>
                  </span>
                </Tooltip>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "狀態",
        width: 70,
        responsive: ["md"],
        render: (item) => {
          const { NowStatusPrimary, NowStatusSecondary } = item;
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.1em" }}>
                {" "}
                {NowStatusPrimary}/{NowStatusSecondary}
              </span>
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 70,
        render: (item) => {
          const {
            NowStatusSecondary,
            AlreadyGraduatedYear,
            NumFirstYearSurvey,
            NumThreeYearSurvey,
            NumFiveYearSurvey,
          } = item;
          return (
            <>
              <Button
                type="dashed"
                style={{
                  color: NowStatusSecondary === "NO" ? "DarkBlack" : "Green",
                }}
                onClick={() => this.handle_show_ui_modal("view", item)}
              >
                <i className="fas fa-user-alt"></i>{" "}
                <span style={{ marginLeft: "4px" }}>明細</span>
              </Button>
              <Button
                type="dashed"
                style={{
                  color: NowStatusSecondary === "NO" ? "DarkBlack" : "Green",
                }}
                onClick={() => this.handle_show_ui_modal("edit", item)}
              >
                <i className="fas fa-user-edit"></i>{" "}
                <span style={{ marginLeft: "4px" }}>修改</span>
              </Button>
              <br />
              <Row>
                <Col span={8}>
                  {AlreadyGraduatedYear === "1" ? (
                    <Button
                      type="dashed"
                      size="small"
                      style={{
                        backgroundColor:
                          NumFirstYearSurvey > 0 ? "PaleGreen" : "Moccasin",
                      }}
                      onClick={() =>
                        NumFirstYearSurvey > 0
                          ? this.handle_show_ui_response(
                              item,
                              NumFirstYearSurvey
                            )
                          : this.handle_show_ui_surveyYear(1, item)
                      }
                      block
                    >
                      {" "}
                      1
                    </Button>
                  ) : (
                    <Button type="dashed" size="small" disabled={true} block>
                      {" "}
                      1
                    </Button>
                  )}
                </Col>
                <Col span={8}>
                  {AlreadyGraduatedYear === "3" ? (
                    <Button
                      type="dashed"
                      size="small"
                      style={{
                        backgroundColor:
                          NumThreeYearSurvey > 0 ? "PaleGreen" : "Moccasin",
                      }}
                      onClick={() =>
                        NumThreeYearSurvey > 0
                          ? this.handle_show_ui_response(
                              item,
                              NumThreeYearSurvey
                            )
                          : this.handle_show_ui_surveyYear(3, item)
                      }
                      block
                    >
                      {" "}
                      3
                    </Button>
                  ) : (
                    <Button type="dashed" size="small" disabled={true} block>
                      {" "}
                      3
                    </Button>
                  )}
                </Col>
                <Col span={8}>
                  {AlreadyGraduatedYear === "5" ? (
                    <Button
                      type="dashed"
                      size="small"
                      style={{
                        backgroundColor:
                          NumFiveYearSurvey > 0 ? "PaleGreen" : "Moccasin",
                      }}
                      onClick={() =>
                        NumFiveYearSurvey > 0
                          ? this.handle_show_ui_response(
                              item,
                              NumFiveYearSurvey
                            )
                          : this.handle_show_ui_surveyYear(5, item)
                      }
                      block
                    >
                      {" "}
                      5
                    </Button>
                  ) : (
                    <Button type="dashed" size="small" disabled={true} block>
                      {" "}
                      5
                    </Button>
                  )}
                </Col>
              </Row>
            </>
          );
        },
      },
    ];
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "NowStatusSecondary":
        switch (param) {
          case "尚待確認":
            return "red";
          case "就業":
          case "服役":
          case "升學":
          case "留學":
            return "green";
          case "其他":
            return "purple";
          default:
            return "default";
        }
      default:
        break;
    }
  }
  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  onChangeCheckbox = (e) => {
    console.log(e.target.checked);
    e.target.checked
      ? this.setState({ undone: "YES" }, () => {
          this.api_page_items(this.current);
        })
      : this.setState({ undone: "NONE" }, () => {
          this.api_page_items(this.current);
        });
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowAlumniInfoModal: true, item });
        break;
      case "edit":
        this.setState({ isEditAlumniInfoModal: true, item });
        break;
      case "delete":
        const { Uid, YearGrade, StudentName } = item;
        // console.log(Uid);
        const msg =
          "您確定刪除 " +
          StudentName +
          " 畢業於 " +
          YearGrade +
          " 學年度的紀錄!!";
        Modal.confirm({
          title: msg,
          onOk: () => {
            this.api_delete_item(Uid);
          },
        });
        break;
      default:
    }
  };

  handle_show_ui_surveyYear = (year, item) => {
    switch (year) {
      case 1:
        this.setState({ isShowSurveyFirstModal: true, item });
        break;
      case 3:
        this.setState({ isShowSurveyThreeModal: true, item });
        break;
      case 5:
        this.setState({ isShowSurveyFiveModal: true, item });
        break;
      default:
        break;
    }
  };

  handle_show_ui_response = (item, yearSurvey) => {
    // console.log(yearSurvey)
    this.setState({ isShowSurveyResponseModal: true });
    this.responseYearSurveyCode = yearSurvey;
    //console.log(this.responseYearSurveyCode)
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      deviceWidth,
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isShowAlumniInfoModal,
      isShowSurveyFirstModal,
      isShowSurveyThreeModal,
      isShowSurveyFiveModal,
      isShowSurveyResponseModal,
      isEditAlumniInfoModal,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
      filterStatus,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="畢業學年度"
          style={{ width: 80, margin: "0 5px", backgroundColor: "lightyellow" }}
          value={searchFieldExtA}
          onChange={(event) =>
            this.setState({ searchFieldExtA: event.target.value })
          }
        />
        <Select
          value={filterStatus}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ filterStatus: value })}
        >
          <Select.Option value="1">畢業一年</Select.Option>
          <Select.Option value="3">畢業三年</Select.Option>
          <Select.Option value="5">畢業五年</Select.Option>
        </Select>
        {deviceWidth > 1200 ? (
          <>
            <Select
              value={searchFieldExtC}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtC: value })}
            >
              <Select.Option value="NONE">部別</Select.Option>
              <Select.Option value="日間部">日間部</Select.Option>
              <Select.Option value="進修部">進修部</Select.Option>
              <Select.Option value="在職專班">在職專班</Select.Option>
              <Select.Option value="假日專班">假日專班</Select.Option>
            </Select>
            <Select
              value={searchFieldExtB}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtB: value })}
            >
              <Select.Option value="NONE">學制</Select.Option>
              <Select.Option value="四技">四技</Select.Option>
              <Select.Option value="二技">二技</Select.Option>
              <Select.Option value="七技">七技</Select.Option>
              <Select.Option value="研究所">研究所</Select.Option>
              <Select.Option value="二專">二專</Select.Option>
              <Select.Option value="三專">三專</Select.Option>
              <Select.Option value="五專">五專</Select.Option>
            </Select>
            <Select
              value={searchFieldExtD}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtD: value })}
            >
              <Select.Option value="NONE">學院</Select.Option>
              <Select.Option value="生活科技學院">生活科技學院</Select.Option>
              <Select.Option value="旅遊學院">旅遊學院</Select.Option>
              <Select.Option value="藝術學院">藝術學院</Select.Option>
              <Select.Option value="管理學院 ">管理學院</Select.Option>
              <Select.Option value="設計學院 ">設計學院</Select.Option>
            </Select>
            <Input
              placeholder="科系"
              style={{ width: 150, margin: "0 5px" }}
              value={searchFieldExtE}
              onChange={(event) =>
                this.setState({ searchFieldExtE: event.target.value })
              }
            />
          </>
        ) : (
          ""
        )}
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索其他條件</Select.Option>
          <Select.Option value="StudentId">畢業生學號</Select.Option>
          <Select.Option value="StudentName">畢業生姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        {deviceWidth > 600 ? (
          <>
            <Button type="primary" onClick={() => this.handle_data_download()}>
              <i className="fas fa-cloud-download-alt element-hidden"></i>
              <span style={{ marginLeft: "4px" }}>下載</span>
            </Button>
          </>
        ) : (
          ""
        )}
        <p></p>
        <Checkbox
          onChange={this.onChangeCheckbox}
          style={{
            margin: "0 0 5px 5px",
            color: "blue",
            fontWeight: "bold",
          }}
        >
          篩選出未調查對象
        </Checkbox>
      </>
    );
    return (
      <>
        {title}
        <Card>
          <Table
            bordered
            scroll={{ y: 480 }}
            loading={loading}
            rowKey="Uid"
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
            columns={this.columns}
          />

          <Modal
            destroyOnClose={true}
            title="顯示基本資料"
            visible={isShowAlumniInfoModal}
            width={1000}
            onOk={() => {
              this.setState({ isShowAlumniInfoModal: false });
            }}
            onCancel={() => {
              this.setState({ isShowAlumniInfoModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <AdumniSingle alumni={item} />
          </Modal>

          <Modal
            destroyOnClose={true}
            title="修改基本資料"
            visible={isEditAlumniInfoModal}
            width={1000}
            onOk={() => {
              this.setState({ isEditAlumniInfoModal: false });
            }}
            onCancel={() => {
              this.setState({ isEditAlumniInfoModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <CounselorEditAlumniModal alumni={item} />
          </Modal>

          <Modal
            destroyOnClose={true}
            title="調查結果"
            visible={isShowSurveyResponseModal}
            width={1000}
            onOk={() => {
              this.setState({ isShowSurveyResponseModal: false });
            }}
            onCancel={() => {
              this.setState({ isShowSurveyResponseModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SurveyResponseModal
              alumni={item}
              yearSurvey={this.responseYearSurveyCode}
            />
          </Modal>

          <Modal
            destroyOnClose={true}
            title="畢業一年調查"
            visible={isShowSurveyFirstModal}
            width={1000}
            onOk={() => {
              this.setState({ isShowSurveyFirstModal: false });
              this.api_page_items(this.current);
            }}
            onCancel={() => {
              this.setState({ isShowSurveyFirstModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SurveyFirstYearModal alumni={item} />
          </Modal>

          <Modal
            destroyOnClose={true}
            title="畢業三年調查"
            visible={isShowSurveyThreeModal}
            width={1000}
            onOk={() => {
              this.setState({ isShowSurveyThreeModal: false });
              this.api_page_items(this.current);
            }}
            onCancel={() => {
              this.setState({ isShowSurveyThreeModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SurveyThreeYearModal alumni={item} />
          </Modal>

          <Modal
            destroyOnClose={true}
            title="畢業五年調查"
            visible={isShowSurveyFiveModal}
            width={1000}
            onOk={() => {
              this.setState({ isShowSurveyFiveModal: false });
              this.api_page_items(this.current);
            }}
            onCancel={() => {
              this.setState({ isShowSurveyFiveModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SurveyFiveYearModal alumni={item} />
          </Modal>

          <BackTop visibilityHeight="80" />
        </Card>
      </>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(SurveyAlumniList);
